// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ loggedIn, sessionChecked, children }) {
  // Session-Check noch nicht abgeschlossen → nichts rendern (kein falscher Redirect)
  if (!sessionChecked) {
    return null;
  }
  if (!loggedIn) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default ProtectedRoute;
